export default __webpack_public_path__ + "static/media/banners_13.1fef309f.png";